import React, {createContext, useEffect, useState} from "react";

export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [userData, setUserData] = useState(localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);



  return (
    <GlobalContext.Provider value={{ userData, setUserData, isLoggedIn, setIsLoggedIn }}>
      {children}
    </GlobalContext.Provider>
  );
}